import {atom, selector} from "recoil";
import {DecodedJWTToken} from "../types/api";

export type User = {
  name: string
}

export const userAtom = atom({
  key: 'user',
  default: {} as DecodedJWTToken
})

export const isUserAdminSelector = selector({
  key: 'isUserAdmin',
  get: ({get}) => {
    const user = get(userAtom);
    return ((user?.accessLevel) == 2 ?? false);
  }
})

export const tokenAtom = atom<string|null>({
  key: "token",
  default: localStorage.getItem("token")
})

export const refreshTokenAtom = atom<string|null>({
  key: "refreshToken",
  default: localStorage.getItem("refreshToken")
})

export const activeTabAtom = atom({
  key: 'activeTabAtom',
  default: 'details'
})

